import React from 'react';
import User from './User';

export default React.createClass({
    propTypes: {
        data: React.PropTypes.array,
        loading: React.PropTypes.bool,
        error: React.PropTypes.bool,
        urls: React.PropTypes.object,
        onRemove: React.PropTypes.func,
        i18n: React.PropTypes.object,
        removeButton: React.PropTypes.bool,
        profilePhotoPlaceholderUrl: React.PropTypes.string
    },
    render() {
        if (this.props.error) {
            return (
                <div className="c-module">
                    <div className="c-module__status">
                        {this.props.i18n.error}
                    </div>
                </div>
            )
        } else if (this.props.loading) {
            return (
                <div className="c-module">
                    <div className="c-module__status">
                        {this.props.i18n.loading}
                    </div>
                </div>
            );
        } else if (!this.props.data) {
            return false;
        } else if (!this.props.data.length) {
            return (
                <div className="c-module">
                    <div className="c-module__status">
                        {this.props.i18n.noResults}
                    </div>
                </div>
            );
        } else {
            return (
                <div className="c-module c-module--nopadding">
                    {this.props.data && this.props.data.map((data) => {
                        return <User
                            key={data.SecureId}
                            data={data}
                            urls={this.props.urls}
                            removeButton={this.props.removeButton}
                            onRemove={this.props.onRemove}
                            i18n={this.props.i18n}
                            profilePhotoPlaceholderUrl={this.props.profilePhotoPlaceholderUrl}
                            />;
                    })}
                </div>
            );
        }
    }
});
